import { render } from "./Footer.vue?vue&type=template&id=4f6afddc"
const script = {}
script.render = render

export default script